export const US_STATES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado',
  'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho',
  'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana',
  'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota',
  'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada',
  'New Hampshire', 'New Jersey', 'New Mexico', 'New York',
  'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon',
  'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota',
  'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington',
  'Washington D.C.', 'West Virginia', 'Wisconsin', 'Wyoming',
];

export const KENYAN_COUNTIES = [
  'Baringo', 'Bomet', 'Bungoma', 'Busia', 'Elgeyo-Marakwet', 'Embu',
  'Garissa', 'Homa Bay', 'Isiolo', 'Kajiado', 'Kakamega', 'Kericho',
  'Kiambu', 'Kilifi', 'Kirinyaga', 'Kisii', 'Kisumu', 'Kitui',
  'Kwale', 'Laikipia', 'Lamu', 'Machakos', 'Makueni', 'Mandera',
  'Marsabit', 'Meru', 'Migori', 'Mombasa', 'Murang\'a', 'Nairobi',
  'Nakuru', 'Nandi', 'Narok', 'Nyamira', 'Nyandarua', 'Nyeri',
  'Samburu', 'Siaya', 'Taita-Taveta', 'Tana River', 'Tharaka-Nithi',
  'Trans Nzoia', 'Turkana', 'Uasin Gishu', 'Vihiga', 'Wajir',
  'West Pokot',
];

export const RELATIONSHIP_INTENTIONS = [
  'Friendship',
  'Serious Dating',
  'Courtship',
  'Marriage-Minded',
];

export const FAITH_OPTIONS = [
  'Christian — Protestant',
  'Christian — Catholic',
  'Christian — Pentecostal',
  'Christian — Seventh-day Adventist',
  'Christian — Other',
  'Muslim',
  'Hindu',
  'Traditional / African Spirituality',
  'Spiritual but not religious',
  'Prefer not to say',
];

export const INTERESTS_LIST = [
  'African Music',
  'Agriculture & Farming',
  'Business & Entrepreneurship',
  'Church & Faith Events',
  'Comedy Shows',
  'Community Events',
  'Cooking',
  'Fashion',
  'Fitness & Wellness',
  'Football / Soccer',
  'Game Nights',
  'Gardening',
  'Gospel Music',
  'Home Projects',
  'Hosting Friends',
  'Live Music',
  'Movie Nights',
  'Movies & TV Shows',
  'Nature Walks / Hiking',
  'Outdoor Adventures',
  'Photography',
  'Picnics',
  'Politics & Current Affairs',
  'Reading',
  'Road Trips',
  'Sports',
  'Technology',
  'Travel',
  'Volunteering',
  'Weekend Getaways',
  'Worship Music',
];

export interface Profile {
  id: string;
  displayName: string;
  age: number;
  gender: 'Male' | 'Female';
  usState: string;
  kenyanCounty: string;
  faith: string;
  intention: string;
  interests: string[];
  bio: string;
  status: 'online' | 'new' | 'verified' | 'premium' | 'offline';
  membershipTier: 'free' | 'premium';
  avatarInitials: string;
  avatarColor: string;
  joinedDate: string;
  lastActive: string;
  profileComplete: number;
  photoUrl?: string | null;
  photoStatus: 'none' | 'pending' | 'approved' | 'rejected';
}

export const MOCK_PROFILES: Profile[] = [
  {
    id: 'profile-001',
    displayName: 'Wanjiru K.',
    age: 31,
    gender: 'Female',
    usState: 'Maryland',
    kenyanCounty: 'Kiambu',
    faith: 'Christian — Protestant',
    intention: 'Marriage-Minded',
    interests: ['Church/Faith community', 'Cooking Kenyan cuisine', 'Travel', 'Fitness & wellness'],
    bio: 'Nairobi-born, Maryland-raised. I work in healthcare and love staying connected to my roots. Looking for someone grounded in faith, family, and ambition. Nyumbani ni nyumbani.',
    status: 'online',
    membershipTier: 'premium',
    avatarInitials: 'WK',
    avatarColor: '#a31911',
    joinedDate: '2026-04-10',
    lastActive: '2026-05-15',
    profileComplete: 98,
    photoStatus: 'approved',
  },
  {
    id: 'profile-002',
    displayName: 'Otieno M.',
    age: 34,
    gender: 'Male',
    usState: 'Texas',
    kenyanCounty: 'Kisumu',
    faith: 'Christian — Catholic',
    intention: 'Serious Dating',
    interests: ['Sports (football/soccer)', 'Entrepreneurship', 'Music & dancing', 'Community events'],
    bio: 'Engineer by day, community builder by night. From the shores of Lake Victoria to the heart of Houston. I value integrity, laughter, and a good nyama choma weekend.',
    status: 'verified',
    membershipTier: 'premium',
    avatarInitials: 'OM',
    avatarColor: '#38761d',
    joinedDate: '2026-03-22',
    lastActive: '2026-05-14',
    profileComplete: 95,
    photoStatus: 'approved',
  },
  {
    id: 'profile-003',
    displayName: 'Aisha N.',
    age: 28,
    gender: 'Female',
    usState: 'Minnesota',
    kenyanCounty: 'Mombasa',
    faith: 'Muslim',
    intention: 'Courtship',
    interests: ['Reading', 'Fashion', 'Cooking Kenyan cuisine', 'Travel'],
    bio: 'Coastal girl at heart, Minneapolis by choice. I\'m a teacher who loves Swahili poetry and weekend farmers markets. Seeking someone intentional, kind, and culturally aware.',
    status: 'new',
    membershipTier: 'free',
    avatarInitials: 'AN',
    avatarColor: '#5a3a8a',
    joinedDate: '2026-05-10',
    lastActive: '2026-05-15',
    profileComplete: 82,
    photoStatus: 'approved',
  },
  {
    id: 'profile-004',
    displayName: 'Kamau J.',
    age: 38,
    gender: 'Male',
    usState: 'Georgia',
    kenyanCounty: 'Nyeri',
    faith: 'Christian — Pentecostal',
    intention: 'Marriage-Minded',
    interests: ['Family & parenting', 'Church/Faith community', 'Agriculture & farming', 'Entrepreneurship'],
    bio: 'Father of one, software architect, and weekend gardener. From the slopes of Mount Kenya to Atlanta. I am looking for a life partner who values God, family, and hard work.',
    status: 'online',
    membershipTier: 'premium',
    avatarInitials: 'KJ',
    avatarColor: '#1a6b8a',
    joinedDate: '2026-02-14',
    lastActive: '2026-05-15',
    profileComplete: 100,
    photoStatus: 'approved',
  },
  {
    id: 'profile-005',
    displayName: 'Zawadi O.',
    age: 26,
    gender: 'Female',
    usState: 'California',
    kenyanCounty: 'Kilifi',
    faith: 'Christian — Seventh-day Adventist',
    intention: 'Serious Dating',
    interests: ['Hiking & outdoors', 'Photography', 'Afrobeats', 'Fitness & wellness'],
    bio: 'Bay Area creative working in UX design. Born in Kilifi, raised between Nairobi and San Jose. I love sunrise hikes, Swahili coast music, and honest conversations.',
    status: 'verified',
    membershipTier: 'premium',
    avatarInitials: 'ZO',
    avatarColor: '#8a6b1a',
    joinedDate: '2026-01-30',
    lastActive: '2026-05-13',
    profileComplete: 97,
    photoStatus: 'approved',
  },
  {
    id: 'profile-006',
    displayName: 'Baraka W.',
    age: 32,
    gender: 'Male',
    usState: 'New York',
    kenyanCounty: 'Kakamega',
    faith: 'Christian — Protestant',
    intention: 'Marriage-Minded',
    interests: ['Music & dancing', 'Benga music', 'Community events', 'Volunteering'],
    bio: 'Bronx-based nurse from Western Kenya. I play guitar on weekends and help run a Kenyan cultural association in NYC. Looking for someone who loves community and isn\'t afraid of commitment.',
    status: 'online',
    membershipTier: 'premium',
    avatarInitials: 'BW',
    avatarColor: '#6b1a8a',
    joinedDate: '2026-03-05',
    lastActive: '2026-05-15',
    profileComplete: 93,
    photoStatus: 'approved',
  },
  {
    id: 'profile-007',
    displayName: 'Njoki P.',
    age: 29,
    gender: 'Female',
    usState: 'Virginia',
    kenyanCounty: 'Murang\'a',
    faith: 'Christian — Catholic',
    intention: 'Courtship',
    interests: ['Reading', 'Politics & current affairs', 'Travel', 'Entrepreneurship'],
    bio: 'Attorney in Northern Virginia. Kikuyu roots, global perspective. I love Ngugi wa Thiong\'o, red wine, and debating Kenyan politics. Seeking an intellectual equal with cultural pride.',
    status: 'verified',
    membershipTier: 'premium',
    avatarInitials: 'NP',
    avatarColor: '#a31911',
    joinedDate: '2026-02-28',
    lastActive: '2026-05-12',
    profileComplete: 96,
    photoStatus: 'approved',
  },
  {
    id: 'profile-008',
    displayName: 'Chebet R.',
    age: 27,
    gender: 'Female',
    usState: 'Ohio',
    kenyanCounty: 'Uasin Gishu',
    faith: 'Christian — Protestant',
    intention: 'Friendship',
    interests: ['Fitness & wellness', 'Hiking & outdoors', 'Cooking Kenyan cuisine', 'Sports (football/soccer)'],
    bio: 'Kalenjin runner turned Columbus accountant. I run half-marathons and make the best ugali this side of the Mississippi. Open to genuine friendships that could grow into more.',
    status: 'new',
    membershipTier: 'free',
    avatarInitials: 'CR',
    avatarColor: '#38761d',
    joinedDate: '2026-05-08',
    lastActive: '2026-05-14',
    profileComplete: 78,
    photoStatus: 'approved',
  },
  {
    id: 'profile-009',
    displayName: 'Mwangi S.',
    age: 36,
    gender: 'Male',
    usState: 'Illinois',
    kenyanCounty: 'Kirinyaga',
    faith: 'Spiritual but not religious',
    intention: 'Serious Dating',
    interests: ['Technology', 'Movies & TV', 'Travel', 'Photography'],
    bio: 'Chicago-based data scientist from Kirinyaga. I believe in honest connections over games. I cook, I travel, and I still watch Vioja Mahakamani reruns when homesick.',
    status: 'offline',
    membershipTier: 'free',
    avatarInitials: 'MS',
    avatarColor: '#4a4a8a',
    joinedDate: '2026-04-18',
    lastActive: '2026-05-10',
    profileComplete: 85,
    photoStatus: 'approved',
  },
  {
    id: 'profile-010',
    displayName: 'Fatuma A.',
    age: 30,
    gender: 'Female',
    usState: 'Washington',
    kenyanCounty: 'Garissa',
    faith: 'Muslim',
    intention: 'Marriage-Minded',
    interests: ['Family & parenting', 'Cooking Kenyan cuisine', 'Fashion', 'Community events'],
    bio: 'Seattle-based pharmacist from Garissa. Faith, family, and food are my three pillars. I am looking for a halal, intentional relationship with someone ready to build a home together.',
    status: 'online',
    membershipTier: 'premium',
    avatarInitials: 'FA',
    avatarColor: '#1a8a6b',
    joinedDate: '2026-03-15',
    lastActive: '2026-05-15',
    profileComplete: 99,
    photoStatus: 'approved',
  },
  {
    id: 'profile-011',
    displayName: 'Kipchoge L.',
    age: 33,
    gender: 'Male',
    usState: 'Pennsylvania',
    kenyanCounty: 'Nandi',
    faith: 'Christian — Protestant',
    intention: 'Marriage-Minded',
    interests: ['Fitness & wellness', 'Hiking & outdoors', 'Church/Faith community', 'Entrepreneurship'],
    bio: 'Philadelphia-based civil engineer from Nandi Hills. I run before work, pray before bed, and build things in between. Searching for a woman who knows her worth and walks in purpose.',
    status: 'verified',
    membershipTier: 'premium',
    avatarInitials: 'KL',
    avatarColor: '#8a4a1a',
    joinedDate: '2026-02-01',
    lastActive: '2026-05-11',
    profileComplete: 94,
    photoStatus: 'approved',
  },
  {
    id: 'profile-012',
    displayName: 'Amina H.',
    age: 25,
    gender: 'Female',
    usState: 'Michigan',
    kenyanCounty: 'Wajir',
    faith: 'Muslim',
    intention: 'Courtship',
    interests: ['Reading', 'Volunteering', 'Fashion', 'Travel'],
    bio: 'Detroit graduate student studying public health. From Wajir but my heart is in building communities wherever I land. Looking for someone patient, purposeful, and ready for something real.',
    status: 'new',
    membershipTier: 'free',
    avatarInitials: 'AH',
    avatarColor: '#6b6b1a',
    joinedDate: '2026-05-12',
    lastActive: '2026-05-15',
    profileComplete: 74,
    photoStatus: 'approved',
  },
];

export const DEMO_CREDENTIALS = {
  email: 'demo@jsnapp.co',
  password: 'JsnDemo2026!',
};

export const ADMIN_CREDENTIALS = {
  email: 'admin@jsnapp.co',
  password: 'JsnAdmin@Secure2026',
  note: 'Admin account — separate from all user accounts',
};